import React from 'react';

const ApiKeyPermissionMappingFormModal = React.lazy(() => import('../components/FormModal'));
const apiKeyPermissionMappingModalRegistry = {
    core_apiKeyPermissionMappingId: ApiKeyPermissionMappingFormModal
};
export default apiKeyPermissionMappingModalRegistry;
